import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutNmfcCodeLookup } from "./autogen/AutogenLayoutNmfcCodeLookup";

export class NmfcCodeLookup extends AutogenLayoutNmfcCodeLookup {

    tableNmfcCodeOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.index > 0) {
            tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
        }
    }
}
